export default __webpack_public_path__ + "assets/eazy-aszf-2022.7121c739.pdf";